import axios from "axios";
import { showAlert, successWarning } from "../components/core/errorHandling";
import AesUtil from "./AESUtil";
import lsencryption from "./lsencryption";

const aesUtil = new AesUtil(256, 1000);

const setCookie = (cname, cvalue) => {
  document.cookie =
    cname + "=" + cvalue + ";path=/;Secure;SameSite=Strict;HttpOnly";
  lsencryption.set(cname, cvalue);
};

const getCookie = (cname) => {
  const value = lsencryption.get(cname);
  return value;
};

const deleteCookie = (cname) => {
  document.cookie = `${cname} = expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;Secure;SameSite=Strict;HttpOnly`;
  localStorage.removeItem(cname);
};

const ignoreEncryption = (p_url) => {
  let aUrlsList = []; // Write thatv URL here you not need ecrypted payload
  return aUrlsList.indexOf(p_url) > -1;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_URL, // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  function (request) {
    let bUrl = request.url === "community/dashboardLogin",
      paramString = JSON.stringify(request.data),
      salt = aesUtil.generateSalt(),
      iv = aesUtil.generateiv(),
      sAuthparam = getCookie("auth-token");
    if (
      request.url != "https://debug.duretechnologies.com/openIssue_nextGen.php"
    ) {
      let encryptParam = bUrl
        ? { _dlt: aesUtil.encrypt(salt, iv, paramString) }
        : { _drp: aesUtil.encrypt(salt, iv, paramString) };
      if (!ignoreEncryption(request.url)) {
        request.data = encryptParam;
        request.headers["_1"] = salt;
        request.headers["_2"] = iv;
      }
      if (sAuthparam) {
        request.headers["auth-token"] = sAuthparam;
      }
    }
    return request;
  },
  function (error, response) {
    showAlert();
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Any status code tha
    //  lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.info(response.config.params.checkTimeout)
    // clearTimeout(response.config.params.checkTimeout);
    let { headers, data } = response,
      authToken = headers["auth-token"];
    if (data && data.status && data.status === 403) {
      successWarning(data.data, data.message, () => {
        // logout();
        console.log("Logout 403");
        deleteCookie("auth-token");
      });
      return Promise.reject(data.message);
    } else {
      if (authToken) {
        // deleteCookie('auth-token');
        setCookie("auth-token", authToken);
      }
      return response;
    }
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log("error calling", error); //sucess
    let { response, code, message } = error;
    // clearTimeout(response.config.params.checkTimeout);
    if (code === "ECONNABORTED") {
      console.log("error ECONNABORTED", code);

      successWarning(code, message, () => {
        console.log("Logout");
        deleteCookie("auth-token");
      });
      return Promise.reject(error);
    } else if (!response.data.error) {
      return Promise.resolve(response);
    } else {
      showAlert();
      return Promise.reject(error);
    }
  }
);

export default instance;
